import type { MapStyle } from "./live-config";
import { buildMapStyleUrl } from "./basemap";

/**
 * Every style a console map surface can be handed: the live-config set plus the internal dark
 * variant used by CAD unit tests (streets-v2-dark so markers stay legible on a night basemap).
 */
export type ConsoleMapStyle = MapStyle | "dark";

/** Operator-facing basemap options for the CAD Layers tile (not the test-only "dark" style). */
export const CAD_BASEMAP_OPTIONS: readonly {
  id: MapStyle;
  label: string;
  description: string;
}[] = [
  {
    id: "streets",
    label: "Streets",
    description: "Named roads and places, dark-friendly vector map",
  },
  {
    id: "satellite",
    label: "Satellite",
    description: "Aerial imagery only",
  },
  {
    id: "hybrid",
    label: "Hybrid",
    description: "Satellite with road labels and place names",
  },
];

/** Human label for a basemap style id. */
export function mapStyleLabel(style: ConsoleMapStyle): string {
  if (style === "dark") {
    return "Dark streets";
  }
  const option = CAD_BASEMAP_OPTIONS.find((entry) => entry.id === style);
  return option?.label ?? "Hybrid";
}

/**
 * MapTiler style URL for console map surfaces (CAD + Setup property map).
 * Uses the real MapTiler map ids from basemap.ts (streets-v2, satellite, hybrid).
 */
export function mapStyleUrl(style: ConsoleMapStyle, key?: string): string {
  if (key === undefined || key.length === 0) {
    return "blank";
  }
  if (style === "dark") {
    return `https://api.maptiler.com/maps/streets-v2-dark/style.json?key=${encodeURIComponent(key)}`;
  }
  return buildMapStyleUrl(key, style);
}

export const DEFAULT_MAP_CENTER: [number, number] = [-85.7585, 38.2527];
export const DEFAULT_MAP_ZOOM = 10;
